var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    [
      _c("template", { slot: "pageContent" }, [
        _c(
          "div",
          { class: ["content bg-light", { expanded: !_vm.isSidebarOpen }] },
          [
            _c(
              "div",
              [
                _c("b-container", { attrs: { fluid: "" } }, [
                  _c(
                    "div",
                    { staticClass: "content-title" },
                    [
                      _c("b-row", [
                        _c("h1", [_vm._v("Daily Reconciliation Report")]),
                      ]),
                      _vm._v(" "),
                      _c("b-row", [
                        _c("span", [
                          _vm._v(
                            "Comprehensive daily reporting for compliance and audit purposes"
                          ),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card p-6" }, [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between",
                        "align-items": "center",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            gap: "1rem",
                            "align-items": "center",
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "fa-light fa-calendar",
                            staticStyle: { "font-size": "1.5rem" },
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticStyle: { "font-weight": "bold" } },
                            [_vm._v("Report Date:")]
                          ),
                          _vm._v(" "),
                          _c("datetime-picker", {
                            staticClass: "z-1",
                            class: {
                              "filter-item-input": true,
                              "filter-item-input-complete": _vm.dateBegin,
                              "error-datepicker": _vm.dateBeginError,
                            },
                            attrs: {
                              format: "DD/MM/YYYY",
                              customInputParentClass: "filter-item-content",
                              maxLength: 19,
                              placeholderValue: _vm.$t(
                                "common.datetime_picker_empty_date"
                              ),
                              inputIcon: "fa-solid fa-calendar",
                            },
                            on: { input: _vm.selectBeginDate },
                            model: {
                              value: _vm.dateBegin,
                              callback: function ($$v) {
                                _vm.dateBegin = $$v
                              },
                              expression: "dateBegin",
                            },
                          }),
                          _vm._v(" "),
                          _vm.dateBeginError
                            ? _c("span", { staticClass: "text-danger" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("errors.Data_format_invalid"))
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-outline-light",
                              on: {
                                click: function ($event) {
                                  _vm.refresh(new Date().toISOString())
                                },
                              },
                            },
                            [_vm._v("Today")]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-outline-light",
                              on: {
                                click: function ($event) {
                                  return _vm.refresh()
                                },
                              },
                            },
                            [_vm._v("Refresh")]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          class: [
                            "btn btn-validate",
                            { disabled: _vm.totalResults == 0 },
                          ],
                          on: {
                            click: function () {
                              return _vm.totalResults > 0
                                ? _vm.exportFiltered()
                                : ""
                            },
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "fa-light fa-arrow-down-to-bracket",
                          }),
                          _vm._v("Generate Daily Report"),
                        ]
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "b-container",
                  { attrs: { fluid: "" } },
                  [
                    _c(
                      "b-row",
                      { staticClass: "stats" },
                      _vm._l(_vm.stats, function (stat, index) {
                        return _c(
                          "b-col",
                          {
                            key: index,
                            on: {
                              click: function ($event) {
                                stat.status != null
                                  ? _vm.selectStatus(stat.status)
                                  : ""
                              },
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "justify-content": "space-between",
                                  "align-items": "center",
                                  width: "100%",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "grid",
                                      "row-gap": "0.5rem",
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: { "text-wrap": "nowrap" },
                                      },
                                      [_vm._v(_vm._s(stat.title))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: { "font-weight": "bold" },
                                      },
                                      [_vm._v(_vm._s(stat.description))]
                                    ),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(_vm._s(stat.description2)),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("i", {
                                  class: ["fa-thin", stat.symbol],
                                  style: {
                                    color: stat.color,
                                    "background-color": stat.background,
                                    display: "flex",
                                    "justify-content": "center",
                                    "align-items": "center",
                                    "font-size": "1.5rem",
                                    height: "3rem",
                                    width: "3rem",
                                    "border-radius": "0.625rem",
                                  },
                                }),
                              ]
                            ),
                          ]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "card p-6" },
                  [
                    _c(
                      "b-row",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                          "justify-content": "space-between",
                          padding: "0rem 1rem",
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              gap: "1rem",
                              "align-items": "center",
                            },
                          },
                          [
                            _vm.totalResults > 0
                              ? _c("span", [
                                  _vm._v(
                                    "Showing " +
                                      _vm._s(_vm.totalResults) +
                                      " " +
                                      _vm._s(
                                        _vm.totalResults > 1
                                          ? "results"
                                          : "result"
                                      ) +
                                      "\n                "
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center",
                                  gap: "1rem",
                                },
                              },
                              [
                                _vm.selectedItems.length > 0
                                  ? _c("span", { staticClass: "selected" }, [
                                      _vm._v(
                                        _vm._s(_vm.selectedItems.length) +
                                          " selected"
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.selectedItems.length > 0
                                  ? _c(
                                      "button",
                                      {
                                        staticClass: "clear",
                                        on: {
                                          click: function ($event) {
                                            return _vm.clearSelection()
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fa-classic fa-xmark",
                                        }),
                                        _vm._v("Clear"),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                              gap: "1rem",
                            },
                          },
                          [
                            _vm.selectedItems.length > 0
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn-outline btn-tertiary",
                                    on: {
                                      click: function ($event) {
                                        return _vm.exportSelected()
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "fa-classic fa-arrow-down-to-line",
                                    }),
                                    _vm._v(
                                      "Export Selected (" +
                                        _vm._s(_vm.selectedItems.length) +
                                        ")"
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn-outline button-primary",
                                on: {
                                  click: function ($event) {
                                    return _vm.exportFiltered()
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "fa-classic fa-arrow-down-to-line",
                                }),
                                _vm._v("Export Filtered"),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn-outline button-primary",
                                on: {
                                  click: function ($event) {
                                    return _vm.exportAll()
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "fa-classic fa-arrow-down-to-line",
                                }),
                                _vm._v("Export All"),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("hr"),
                    _vm._v(" "),
                    _vm.items != null
                      ? _c(
                          "div",
                          [
                            _vm.totalResults > 0
                              ? [
                                  _c("b-table", {
                                    staticStyle: { "margin-bottom": "0" },
                                    attrs: {
                                      responsive: "",
                                      items: _vm.items,
                                      fields: _vm.fields,
                                      "primary-key": "id",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "head(checkbox)",
                                          fn: function () {
                                            return [
                                              _c(
                                                "label",
                                                {
                                                  staticClass:
                                                    "custom-checkbox",
                                                },
                                                [
                                                  _c("input", {
                                                    attrs: {
                                                      type: "checkbox",
                                                      id: "all",
                                                      name: "checkAll",
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.selectAll(
                                                          $event
                                                        )
                                                      },
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "checkmark",
                                                  }),
                                                ]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                        {
                                          key: "cell(checkbox)",
                                          fn: function (data) {
                                            return [
                                              _c(
                                                "label",
                                                {
                                                  staticClass:
                                                    "custom-checkbox",
                                                },
                                                [
                                                  _c("input", {
                                                    attrs: { type: "checkbox" },
                                                    domProps: {
                                                      value: data.item,
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.toggleSelection(
                                                          $event,
                                                          data.item
                                                        )
                                                      },
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "checkmark",
                                                  }),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                        {
                                          key: "cell(time)",
                                          fn: function (data) {
                                            return [
                                              data.item.CreationDate
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        data.item.CreationDate.split(
                                                          "T"
                                                        )[1]
                                                      )
                                                    ),
                                                  ])
                                                : _c("span", [_vm._v("—")]),
                                            ]
                                          },
                                        },
                                        {
                                          key: "cell(orderreference)",
                                          fn: function (data) {
                                            return [
                                              data.item.Invoices[0] &&
                                              data.item.Invoices[0]
                                                .InvoiceIdentifier
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        data.item.Invoices[0]
                                                          .InvoiceIdentifier
                                                      )
                                                    ),
                                                  ])
                                                : _c("span", [_vm._v("—")]),
                                            ]
                                          },
                                        },
                                        {
                                          key: "cell(paymentreference)",
                                          fn: function (data) {
                                            return [
                                              data.item.Reference1
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        data.item.Reference1
                                                      )
                                                    ),
                                                  ])
                                                : _c("span", [_vm._v("—")]),
                                            ]
                                          },
                                        },
                                        {
                                          key: "cell(transactionType)",
                                          fn: function (data) {
                                            return [
                                              data.item.Type == 1 &&
                                              data.item.Direction == 0
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "btn btn-empty",
                                                      staticStyle: {
                                                        display: "flex",
                                                        gap: "0.5rem",
                                                        "align-items": "center",
                                                        "justify-content":
                                                          "center",
                                                        cursor: "default",
                                                        color: "#008236",
                                                        "background-color":
                                                          "#f0fdf4",
                                                        "border-color":
                                                          "#b9f8cf",
                                                      },
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa-light fa-credit-card",
                                                      }),
                                                      _vm._v(
                                                        "\n                    Payment\n                  "
                                                      ),
                                                    ]
                                                  )
                                                : data.item.Type == 0 &&
                                                  data.item.Direction == 1
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "btn btn-empty",
                                                      staticStyle: {
                                                        display: "flex",
                                                        gap: "0.5rem",
                                                        "align-items": "center",
                                                        "justify-content":
                                                          "center",
                                                        cursor: "default",
                                                        color: "#1d4ed8",
                                                        "background-color":
                                                          "#eff6ff",
                                                        "border-color":
                                                          "#bfdbfe",
                                                      },
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa-light fa-money-bill",
                                                      }),
                                                      _vm._v(
                                                        "\n                    Order\n                  "
                                                      ),
                                                    ]
                                                  )
                                                : data.item.Type == 11 ||
                                                  data.item.Type == 3
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "btn btn-empty",
                                                      staticStyle: {
                                                        display: "flex",
                                                        gap: "0.5rem",
                                                        "align-items": "center",
                                                        "justify-content":
                                                          "center",
                                                        cursor: "default",
                                                        color: "#a16207",
                                                        "background-color":
                                                          "#fefce8",
                                                        "border-color":
                                                          "#fef08a",
                                                      },
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa-light fa-money-bill-transfer",
                                                      }),
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            data.item.Type == 11
                                                              ? "Refund"
                                                              : data.item
                                                                  .Type == 3
                                                              ? "Credit Note"
                                                              : ""
                                                          ) +
                                                          "\n                  "
                                                      ),
                                                    ]
                                                  )
                                                : _c("span", [_vm._v("—")]),
                                            ]
                                          },
                                        },
                                        {
                                          key: "cell(viban)",
                                          fn: function (data) {
                                            return [
                                              data.item.VIBAN !== ""
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(data.item.VIBAN)
                                                    ),
                                                  ])
                                                : _c("span", [_vm._v("—")]),
                                            ]
                                          },
                                        },
                                        {
                                          key: "cell(amount)",
                                          fn: function (data) {
                                            return [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    data.item.Amount + "€"
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          },
                                        },
                                        {
                                          key: "cell(type)",
                                          fn: function (data) {
                                            return [
                                              data.item.ReconciliationMode == 1
                                                ? _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "btn-tertiary-full",
                                                      staticStyle: {
                                                        cursor: "default",
                                                        gap: "0.5rem",
                                                        display: "flex",
                                                        "align-items": "center",
                                                        color: "#fff",
                                                        "background-color":
                                                          "#155dfc",
                                                        "border-color":
                                                          "#155dfc",
                                                      },
                                                    },
                                                    [_vm._v("Auto")]
                                                  )
                                                : data.item
                                                    .ReconciliationMode == 2
                                                ? _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "btn-tertiary-full",
                                                      staticStyle: {
                                                        cursor: "default",
                                                        gap: "0.5rem",
                                                        display: "flex",
                                                        "align-items": "center",
                                                        color: "#364153",
                                                        "background-color":
                                                          "#fbf9fa",
                                                        "border-color":
                                                          "#ebe6e7",
                                                      },
                                                    },
                                                    [_vm._v("Manual")]
                                                  )
                                                : _c("span", [_vm._v("—")]),
                                            ]
                                          },
                                        },
                                        {
                                          key: "cell(reconciledBy)",
                                          fn: function (data) {
                                            return [
                                              data.item.ReconciliationMode == 1
                                                ? _c("span", [_vm._v("System")])
                                                : data.item
                                                    .ReconciliationMode == 2
                                                ? _c("span", [_vm._v("User")])
                                                : _c("span", [_vm._v("—")]),
                                            ]
                                          },
                                        },
                                        {
                                          key: "cell(status)",
                                          fn: function (data) {
                                            return [
                                              Number(data.item.Status) == 2
                                                ? _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "btn-tertiary-full",
                                                      staticStyle: {
                                                        cursor: "default",
                                                        gap: "0.5rem",
                                                        display: "flex",
                                                        "align-items": "center",
                                                        color: "#a16207",
                                                        "background-color":
                                                          "#fefce8",
                                                        "border-color":
                                                          "#fef08a",
                                                      },
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa-light fa-clock",
                                                      }),
                                                      _vm._v("Pending"),
                                                    ]
                                                  )
                                                : Number(data.item.Status) == 3
                                                ? _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "btn-tertiary-full",
                                                      staticStyle: {
                                                        cursor: "default",
                                                        gap: "0.5rem",
                                                        display: "flex",
                                                        "align-items": "center",
                                                        color: "#008236",
                                                        "background-color":
                                                          "#f0fdf4",
                                                        "border-color":
                                                          "#b9f8cf",
                                                      },
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa-light fa-circle-check",
                                                      }),
                                                      _vm._v("Reconciled"),
                                                    ]
                                                  )
                                                : Number(data.item.Status) == 1
                                                ? _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "btn-tertiary-full",
                                                      staticStyle: {
                                                        cursor: "default",
                                                        gap: "0.5rem",
                                                        display: "flex",
                                                        "align-items": "center",
                                                        color: "#c10007",
                                                        "background-color":
                                                          "#fef2f2",
                                                        "border-color":
                                                          "#c1000773",
                                                      },
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "fa-light fa-triangle-exclamation",
                                                      }),
                                                      _vm._v("Not Reconciled"),
                                                    ]
                                                  )
                                                : _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "btn-tertiary-full",
                                                      staticStyle: {
                                                        cursor: "default",
                                                        gap: "0.5rem",
                                                        display: "flex",
                                                        "align-items": "center",
                                                        color: "#364153",
                                                        "background-color":
                                                          "#fbf9fa",
                                                        "border-color":
                                                          "#ebe6e7",
                                                      },
                                                    },
                                                    [_vm._v("Active")]
                                                  ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      4126471945
                                    ),
                                  }),
                                ]
                              : _c("b-row", [
                                  _c("span", [
                                    _vm._v(
                                      "No reconciliations found for " +
                                        _vm._s(
                                          this.dateBegin.replaceAll("/", ".")
                                        )
                                    ),
                                  ]),
                                ]),
                          ],
                          2
                        )
                      : _c(
                          "div",
                          {
                            staticClass: "empty",
                            staticStyle: {
                              display: "flex",
                              "justify-content": "center",
                            },
                          },
                          [_c("b-spinner", { attrs: { label: "Loading..." } })],
                          1
                        ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "card p-6",
                    staticStyle: {
                      display: "flex",
                      "justify-content": "space-between",
                      "align-items": "center",
                      "background-color": "#f8f9fa !important",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          gap: "2rem",
                          color: "#4a5565",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            "\n              Report generated: " +
                              _vm._s(this.dateNow) +
                              "\n            "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("span", [_vm._v("•")]),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            "\n              Period: " +
                              _vm._s(this.dateBegin) +
                              "\n            "
                          ),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          color: "#4a5565",
                          display: "flex",
                          gap: "1rem",
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "fa-light fa-circle-check",
                          staticStyle: { color: "#00a63e" },
                        }),
                        _vm._v("Audit-ready format"),
                      ]
                    ),
                  ]
                ),
              ],
              1
            ),
          ]
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }